{
  "nextPage": false,
  "logs": [
    {
      "identifier": {
        "entityKey": null,
        "document": "123141234",
        "name": null,
        "matchKey": "AAAAAAAAAAAAAAAAAAA._NA_.test@email.com.EP",
        "document_hash": "a5ksRxCvN+TEST/TEST/fRHJQw=="
      },
      "changes": {
        "purposingProfiles": [],
        "criterios": "",
        "requestId": "test-test-4b78-test-d83acabc918c",
        "fields": {
          "direccion": {
            "before": null,
            "after": "test"
          }
        },
        "operation": "DIS",
        "comentarios": "Edición Masiva"
      },
      "operator": {
        "date": "2026-03-31T18:06:45.252000000Z",
        "ip": "",
        "domain": "AR_CONTACT_DATA",
        "subdomain": "EMAIL",
        "origen": "DM",
        "user": "mfc20",
        "matriz": null
      }
    }
  ]
}
